import React, { Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';

import MainLayout from './layout/MainLayout';
import LoadingSpinner from './components/lib/UI/loadingSpinner/LoadingSpinner';
import './scss/App.scss';
import AppInit from 'app-initializer';
import DayReportDetails from 'pages/DayReportDetails';
import UsersPage from 'pages/UsersPage';
import UserDetailsPage from 'pages/UserDetailsPage';
import AddUserPage from 'pages/AddUserPage';
import StoreDetailsPage from 'pages/StoreDetailsPage';
import AddStorePage from 'pages/AddStorePage';
import StoresPage from './pages/StoresPage';
import ChangeUserPasswordPage from 'pages/ChangeUserPasswordPage';
import ForgotPasswordPage from 'pages/ForgotPasswordPage';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import { useAppActions } from 'actions/app-actions';
import { AppErrorStatusCode } from 'common/constants';
import { AppStateController } from 'common/controller/AppStateController';
import UILogger from 'common/utils/logger';
import { store } from 'setup/store';
import NonAuthAppInit from 'non-auth-app-initializer';
import ChangePasswordPage from 'pages/ChangePasswordPage';
import DayReportStatusPage from 'pages/DayReportStatusPage';
import RoyaltyFormResponsesPage from 'pages/RoyaltyFormResponsesPage';
import RoyaltyReportsPage from 'pages/RoyaltyReportsPage';

const Dashboard = React.lazy(() => import('./pages/Dashboard'));
// const Customers = React.lazy(() => import('./pages/Customers'));
// const CustomerEdit = React.lazy(() => import('./pages/CustomerEdit'));
// const Products = React.lazy(() => import('./pages/Products'));
// const ProductEdit = React.lazy(() => import('./pages/ProductEdit'));
const NotFound = React.lazy(() => import('./pages/NotFound'));
const BlankPage = React.lazy(() => import('./pages/BlankPage'));
const Login = React.lazy(() => import('./pages/Login'));
const DayReports = React.lazy(() => import('./pages/DayReports'));
const Stores = React.lazy(() => import('./pages/StoresPage'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route element={<AppInit />}>
            {/* <Route element={<AuthLayout />}> */}
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/users/:userId" element={<UserDetailsPage />} />
              <Route path="/users/add-new" element={<AddUserPage />} />
              <Route path="/users/change-password/:userId" element={<ChangeUserPasswordPage />} />

              <Route path="/stores" element={<StoresPage />} />
              <Route path="/stores/:storeId" element={<StoreDetailsPage />} />
              <Route path="/stores/add-new" element={<AddStorePage />} />

              {/* <Route path="/customers" element={<Customers />} />
              <Route path="/customers/:customerId" element={<CustomerEdit />} /> */}
              {/* <Route path="/products" element={<Products />} />
              <Route path="/products/:productId" element={<ProductEdit />} /> */}
              <Route path="/reports" element={<DayReports />} />
              <Route path="/reports/:reportId" element={<DayReportDetails />} />
              <Route path="/analytics" element={<BlankPage />} />
              <Route path="/discount" element={<BlankPage />} />
              <Route path="/inventory" element={<BlankPage />} />
              <Route path="/profile" element={<BlankPage />} />
              <Route path="/change-password" element={<ChangePasswordPage />} />
              <Route path="/day-report-status" element={<DayReportStatusPage />} />
              <Route path="/form-responses/:reportId" element={<RoyaltyFormResponsesPage />} />
              <Route path="/royalty" element={<RoyaltyReportsPage />} />
            </Route>
          </Route>

          <Route element={<NonAuthAppInit />}>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
